import { render, staticRenderFns } from "./InstanceName.vue?vue&type=template&id=72dc7c06&"
import script from "./InstanceName.vue?vue&type=script&lang=js&"
export * from "./InstanceName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports